import { render, staticRenderFns } from "./Iconarea.vue?vue&type=template&id=7ebd2ff4&scoped=true&"
import script from "./Iconarea.vue?vue&type=script&lang=js&"
export * from "./Iconarea.vue?vue&type=script&lang=js&"
import style0 from "./Iconarea.vue?vue&type=style&index=0&id=7ebd2ff4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ebd2ff4",
  null
  
)

export default component.exports